function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.8 11.18L20.42 6.78C19.9 5.13 18.37 4 16.64 4H4C2.9 4 2 4.9 2 6V14.06C2 15.12 2.82 15.99 3.88 16.06L8.24 16.31H8.35L12 20.08C12.57 20.66 13.35 21 14.16 21H14.77C16.22 21 17.19 19.51 16.6 18.19L15.92 16.67L17.21 16.8C18.81 16.96 20.37 16.22 21.26 14.89C21.99 13.8 22.18 12.44 21.79 11.19L21.8 11.18ZM4 6H7.3V14.25L4 14.06V6ZM19.89 11.77C20.1 12.45 20 13.18 19.6 13.77C19.12 14.49 18.28 14.89 17.41 14.8L14.4 14.5C14.04 14.46 13.7 14.62 13.49 14.91C13.28 15.2 13.24 15.58 13.39 15.9L14.77 18.99H14.16C13.89 18.99 13.63 18.88 13.44 18.68L9.52 14.63L9.3 14.4V6H16.64C17.5 6 18.25 6.56 18.51 7.37L19.89 11.77Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=ThumbDown.js.map